export const VALID_FILE_FORMATS = /(\.jpeg|\.jpg|\.png|\.docx|\.doc|\.xlsx|\.xls|\.pdf|\.csv|\.msg)$/i;
export const MAX_FILE_SIZE_BYTES = 35 * 1024 * 1024;
export const MAX_ATTACHMENTS = 5;

type TranslateFn = (key: string, options?: Record<string, unknown>) => string;

type AddAttachmentsArgs = {
  existingAttachments: File[];
  newFiles: File[];
  t: TranslateFn;
  onError: (message: string) => void;
};

export const getValidatedAttachments = ({
  existingAttachments,
  newFiles,
  t,
  onError,
}: AddAttachmentsArgs): File[] => {
  const existingNames = new Set(existingAttachments.map(file => file.name));
  const validNew: File[] = [];

  for (const file of newFiles) {
    if (existingAttachments.length + validNew.length >= MAX_ATTACHMENTS) {
      onError(t('notification.createTask.attachments.maxAttachmentsExceeded'));
      break;
    }

    if (!VALID_FILE_FORMATS.exec(file.name.toLowerCase())) {
      onError(
        t('notification.createTask.attachments.invalidFormat', {
          fileTypes: t('notification.createTask.attachments.fileTypesLabel'),
        }),
      );
      continue;
    }

    if (file.size > MAX_FILE_SIZE_BYTES) {
      onError(t('notification.createTask.attachments.sizeLimitPerFile'));
      continue;
    }

    if (existingNames.has(file.name)) {
      onError(t('notification.createTask.attachments.fileAlreadyExists'));
      continue;
    }

    existingNames.add(file.name);
    validNew.push(file);
  }

  if (!validNew.length) return existingAttachments;
  return [...existingAttachments, ...validNew].slice(0, MAX_ATTACHMENTS);
};
